import clientSay1 from "images/client1.png";
import clientSay4 from "images/client2.png";
import clientSay5 from "images/client3.png";
import clientSay6 from "images/client4.png";

export const globalJson = {
  prod_company_id: 152,
  dev_company_id: 238,

  // apiUtil auth header key
  authToken: "Bearer 168|3oLFn8OniSxk1UBTO3eQeGXMuViDTsZqAwhalwWm",
  companyId: "7514a219-48ce-439e-a2c5-6f38980cee1a",
  stripePublishableKey:
    "pk_live_51LdnoABqYa4ICTHoC6CjEgImHYOvUXXPs8psg8jZqXPxRwBt99nQEWtFFJj2n3ublkCJa0S8pYzDtvStF2JxUPzU00uWCskvlb",
  mapKey: "AIzaSyDKEntg7JydrxI7zr2tQL5OYcS5M-er-bc",
  residenceStateCode: "AZ",

  //email confirmation admin token
  adminEmailToken:
    "XR85jFku2zMMqvsYmAdkrk1lm6pozj7eFXetRHLNSSsLxRLnAHgY3dPaVsE27OK8cIbnhFQmncWxVjS1XLAhneFEFpwVVeaNE7hMOym2vrhzdKSmxn99V0fLvVJyZLPT",
  websiteLink: "https://AMK Elite Car Rentals-dev.1now.app",
  sender: "AMK Elite Car Rentals",
  ccEmail: "AMK Elite Car Rentals@gmail.com",

  // apiUtil sendNewsLetterEmail
  util_serviceId: "service_2xca7kj",
  util_templateId: "template_smckeo7",
  util_userId: "ATdsFr5wumje11YkV",
  util_privateKey: "TJyyV_e7nNOGPKbyyjpMB",
  util_contact_templateId: "template_9dsuz0w",

  // apiUtil getBonzahToken
  client_secret_dev: "",
  client_id_dev: "",
  client_secret_prod: "",
  client_id_prod: "",

  about_us_para:
    "AMK Elite Car Rental is a family-owned business committed to providing a seamless and premium car rental experience. We offer a curated fleet of luxury and performance vehicles, delivering to Sacramento International Airport (SMF) and other custom locations for your convenience. Whether for business, leisure, or special occasions, we take pride in delivering top-tier service tailored to your needs.",

  clientSays_arr: [
    {
      id: 1,
      clientName: "Diana Tarakanova",
      clientAddress: "Townsed, Delaware",
      content:
        "We got a BMW X5 for a work trip and were seriously impressed! The car drove like a dream—steady on the road, super comfortable, and worth every penny. We almost extended the rental because we didn’t want to give it back! AMK made the whole process easy. Five stars, and we’ll definitely be back next time we’re in Sacramento.",
      img: clientSay1,
    },
    {
      id: 2,
      clientName: "Julieta Brooks",
      clientAddress: "Hockessin, Delaware",
      content:
        "Wow! What a car! It drives smoothly and it’s spacious! Did I mention how beautiful it is too? Made this mom of two littles feel safe, comfortable, and a bit fancy! ❤️ the costumer service was on point and I’d get a response within 15 minutes! If I’m ever in Sacramento again I know who to reach out to",
      img: clientSay4,
    },
    {
      id: 3,
      clientName: "Hailey Tabarez",
      clientAddress: "Dover, Delaware",
      content:
        "I had the pleasure of renting from Aleksandr. The car was in wonderful condition! Communication was fast and pickup instructions were easy to follow. Last minute I needed to extend my trip and Aleksandr was very accommodating. 10/10 would recommend renting from him. I know I will again!",
      img: clientSay5,
    },
    {
      id: 4,
      clientName: "Q Dubb",
      clientAddress: "Elsmere, Delaware",
      content:
        "Great company with a fleet of cars you won't find at your typical car rental place. I had a sweet Audi Q7 Quattro that got compliments from my family members. Host is professional and prompt. Would definitely recommend!",
      img: clientSay6,
    },
  ],

  //social links
  facebook: "https://www.facebook.com/",
  instagram:
    "https://www.instagram.com/bluediamond.enterprise/profilecard/?igsh=ZnNpM2t3Y2JrbDh2",

  //contact
  address: "1911 Finney Way, Lincoln, CA, 95648",
  operating_time: "09:00 am - 7:00 pm",
  addressLink:
    "https://www.google.com/maps/place/4830+W+Kennedy+Blvd,+Tampa,+FL+33609,+USA/data=!4m2!3m1!1s0x88c2c2e4b61fbe87:0x7fa31f86943d0895?sa=X&ved=1t:242&ictx=111",
  phone: "+1 (916)906-5099",
  email: "Amkelitecarrentals@gmail.com",
  company_name: "AMK Elite Car Rentals",
};

export const scriptHubSpot = document.createElement("script");
scriptHubSpot.src = "//js-na1.hs-scripts.com/46776911.js";
scriptHubSpot.async = true;
scriptHubSpot.defer = true;
scriptHubSpot.id = "hs-script-loader";
